import React, { useContext } from 'react';
import { Content } from './styles';
import { ThemeContext } from 'styled-components';

const TableRow = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <Content height={24} width={500} speed={1.2} {...props}>
      <rect x="5" y="6" rx="4" ry="4" width={10} height="8" />
      <rect x="30" y="6" rx="4" ry="4" width={30 * random} height="8" />
      <rect x="70" y="6" rx="4" ry="4" width={180 * random} height="8" />
      <rect x="320" y="6" rx="4" ry="4" width={70} height="8" />
      <rect x="460" y="6" rx="4" ry="4" width={35} height="8" />
    </Content>
  );
};

const FilaDownloadLoader = () => {
  const themeContext = useContext(ThemeContext);

  return (
    <>
      {Array(10)
        .fill('')
        .map((e, i) => (
          <TableRow
            key={i}
            style={{ opacity: Number(2 / i).toFixed(1) }}
            backgroundColor={themeContext?.loadingTableColor}
            foregroundColor={themeContext?.loadingTableColor}
            primaryopacity={1}
            secondaryopacity={0.6}
          />
        ))}
    </>
  );
};

export default FilaDownloadLoader;
